<template>
    <a href="#" :class="classes" @click.prevent="toggleLike" :title="titleText">
        <span class="icon-thumbs-up"></span>{{ likeText }}
    </a>
</template>

<script>
export default {
    props: {
        url: String,
        likes: Number,
        isLiking: Boolean,
        enabled: Boolean
    },

    mounted() {
        this.disableButton = !this.enabled;

        this.isLikingProp = this.isLiking;

        this.likesProp = this.likes;
    },

    data: function () {
        return {
            disableButton: false,
            isLikingProp: false,
            likesProp: 0
        };
    },

    computed: {
        likeText: function () {
            if (this.isLikingProp) return 'Gillar';
            else return 'Gilla';
        },

        titleText: function () {
            if (this.disableButton) return 'Du måste vara inloggad för att kunna gilla!';
            else return 'Gilla kommentaren!';
        },

        classes: function () {
            return {
                'like-comment-button': true,
                btn: true,
                'btn-sm': true,
                off: this.isLikingProp,
                on: !this.isLikingProp,
                disabled: !this.enabled
            };
        }
    },

    methods: {
        toggleLike: function () {
            if (this.disableButton) return;

            this.disableButton = true; // Disable button

            this.isLikingProp = !this.isLikingProp;

            this.increaseOrDecreaseLikes();

            var callback = function (err, res) {
                if (err) {
                    this.isLikingProp = !this.isLikingProp;
                    this.increaseOrDecreaseLikes();
                    console.error(err);
                }

                this.disableButton = false; // Enable button
            };

            request.post(this.url).end(callback.bind(this));
        },

        increaseOrDecreaseLikes: function () {
            if (this.isLikingProp) {
                this.likesProp++;
            } else {
                this.likesProp--;
            }
        }
    }
};
</script>
